"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStoreKey = '__WEDUX_STORE__';

function createUUIDFactory() {
  var index = 0;
  return function (namespace) {
    if (namespace === void 0) {
      namespace = exports.defaultStoreKey;
    }

    return "" + namespace + index++ + "__";
  };
}

exports.createUUIDFactory = createUUIDFactory;
exports.uuid = createUUIDFactory();

function isFn(obj) {
  return typeof obj === 'function';
}

exports.isFn = isFn;

function isString(obj) {
  return typeof obj === 'string';
}

exports.isString = isString;

function compose() {
  var funcs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    funcs[_i] = arguments[_i];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      return a(b.apply(void 0, args));
    };
  });
}

exports.compose = compose; // Bind an object/factory of actions to the store and wrap them.

function mapActions(actions, store) {
  if (isFn(actions)) actions = actions(store);
  var mapped = {};

  for (var i in actions) {
    mapped[i] = store.action(actions[i]);
  }

  return mapped;
}

exports.mapActions = mapActions; // select('foo,bar') creates a function of the form: ({ foo, bar }) => ({ foo, bar })

function select(properties) {
  if (isString(properties)) properties = properties.split(/\s*,\s*/);
  return function (state) {
    var selected = {};

    for (var i = 0; i < properties.length; i++) {
      selected[properties[i]] = state[properties[i]];
    }

    return selected;
  };
}

exports.select = select;